import React, { Component } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import PropTypes from 'prop-types';
import { withRouter } from '../_helpers/withRouter';
import { connect } from "react-redux";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import { history } from '../_helpers';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { withStyles } from '@mui/styles';
import { usuarioAction } from '../_actions';
import { Button, Form, FormGroup } from 'reactstrap';
import Swal from 'sweetalert2';

const styles = theme => ({
    paper: {
        marginTop: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: 8,
        backgroundColor: theme.palette,
        width: 72,
        height: 72
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: 24
    },
    submit: {
        margin: '24px 0 16px',
        color: '#ffffff'
    },
    backButton: {
        marginTop: theme.spacing,
    }
});

class PasswordReset extends Component {

    state = {
        submitted: false,
        login: '',
        token: '',
        password: '',
        repeatPassword: '',
    }

    componentDidMount() {

        const query = new URLSearchParams(this.props.location.search);
        var login = query.toString().substr(6, (query.toString().indexOf("&", 0)) - 6);
        this.setState({ login: decodeURIComponent(login) });

        var token = query.toString().substr(query.toString().indexOf("token=", 0) + 6, (query.toString().length - query.toString().indexOf("token=", 0) - 6));
        token = token.substr(0, token.indexOf("&"));
        this.setState({ token: token });

        var email = query.toString().substr(query.toString().indexOf("email=", 0) + 6, (query.toString().length - query.toString().indexOf("email=", 0) - 6));
        this.setState({ email: decodeURIComponent(email) });

        var d = new Date();
        var milli = d.getTime();
        if (milli > token) {
            Swal.fire({
                title: 'Atenção',
                text: 'A validade desse link expirou.',
                icon: 'warning',
                buttons: true,
                showCancelButton: false,
                confirmButtonText: 'Sim',
                cancelButtonText: "Não",
                dangerMode: true,
                heightAuto: false
            })
                .then((willDelete) => {
                    if (willDelete.value) {
                        history.push("/");
                    }
                });
        }
    }

    handleChangePassword = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    handleChangeRepeatPassword = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    handleSubmit = (event) => {
        this.setState({ submitted: true }, () => {
            setTimeout(() => this.setState({ submitted: false }), 2500);
        });
        const { dispatch } = this.props;
        let payload = {
            login: this.state.email, //vem assim da autorização
            token: this.state.login, //vem assim da autorização
            senha: this.state.password
        };
        dispatch(usuarioAction.passwordReset(payload, this.state.token));
    }

    render() {
        const { submitted } = this.state;
        const { classes } = this.props;

        return (
            <Container component={Paper} maxWidth="sm">
                <CssBaseline />
                <div className={classes.paper}>
                    <Grid container justifyContent="flex-start" sx={{ width: '100%' }}>
                        <IconButton className={classes.backButton} onClick={() => history.goBack()} aria-label="Voltar" color="primary">
                            <KeyboardBackspaceIcon />
                        </IconButton>
                    </Grid>
                    <Typography component="h2" variant="h6">
                        Informe e confirme a nova senha.
                    </Typography>
                    <Typography component="h5" variant="h6">
                        {this.state.email}
                    </Typography>

                    <Form style={{ marginTop: 10 }}>

                        <FormGroup className="input-group mb-2">
                            <input
                                autoFocus
                                type="password"
                                name="senha"
                                id="senha"
                                value={this.state.password}
                                className="form-control"
                                onChange={this.handleChangePassword('password')}
                                placeholder="Nova Senha *"
                            />
                        </FormGroup>

                        <FormGroup className="input-group mb-2">
                            <input
                                autoFocus
                                type="password"
                                name="repeatPassword"
                                id="repeatPassword"
                                value={this.state.repeatPassword}
                                className="form-control"
                                onChange={this.handleChangeRepeatPassword('repeatPassword')}
                                placeholder="Repita a Nova Senha *"
                            />
                        </FormGroup>

                        <Button
                            onClick={(event) => this.handleSubmit(event)}
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={submitted}
                            className={classes.submit}
                        >
                            {
                                (submitted && 'Enviando informações...')
                                || (!submitted && 'Alterar')
                            }
                        </Button>

                    </Form>

                </div>
            </Container>
        );
    }
}
PasswordReset.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return state;
}
const connectedPasswordResetPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(withStyles(styles)(PasswordReset)));
export { connectedPasswordResetPage as PasswordReset };